import { Link } from "react-router-dom";
import { Gauge, Calendar, Fuel, Cog, MapPin } from "lucide-react";
import { formatPrice, formatKm } from "../mock";

export default function CarCard({ car }) {
  return (
    <Link
      to={`/auto/${car.id}`}
      className="group block bg-white rounded-2xl overflow-hidden border border-gray-100 card-hover"
    >
      {/* Image */}
      <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
        <img
          src={car.image}
          alt={`${car.brand} ${car.model}`}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 bg-[#16181d]/85 text-white text-xs font-semibold px-3 py-1 rounded-full backdrop-blur">
          {car.condition}
        </span>
        {car.neopatentati && (
          <span className="absolute top-3 right-3 bg-emerald-500 text-white text-[11px] font-semibold px-2.5 py-1 rounded-full">
            Neopatentati
          </span>
        )}
      </div>

      {/* Body */}
      <div className="p-4">
        <h3 className="font-display font-bold text-lg text-[#16181d] leading-tight">
          {car.brand} <span className="text-[#e2001a]">{car.model}</span>
        </h3>
        <p className="text-sm text-gray-500 mt-0.5 line-clamp-1">{car.trim}</p>

        {/* Specs */}
        <div className="grid grid-cols-2 gap-2 mt-4 text-[13px] text-gray-600">
          <span className="inline-flex items-center gap-1.5">
            <Gauge className="w-4 h-4 text-gray-400" /> {formatKm(car.km)}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Calendar className="w-4 h-4 text-gray-400" /> {car.month}/{car.year}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Fuel className="w-4 h-4 text-gray-400" /> {car.fuel}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Cog className="w-4 h-4 text-gray-400" /> {car.gearbox}
          </span>
        </div>

        {/* Price */}
        <div className="mt-4 pt-4 border-t border-gray-100 flex items-end justify-between">
          <div>
            <p className="text-[11px] text-gray-400 leading-none mb-1">Prezzo</p>
            <p className="font-display font-extrabold text-2xl text-[#16181d]">
              {formatPrice(car.price)}
            </p>
          </div>
          <span className="inline-flex items-center gap-1 text-xs text-gray-500">
            <MapPin className="w-3.5 h-3.5" /> {car.location}
          </span>
        </div>
      </div>
    </Link>
  );
}
